import { statusColorEnum } from "../utils/enums";

export const statusColorMixin = {
  methods: {
    selectColorFor(status) {
      return statusColorEnum[status];
    }
  },
  computed: {
    backgroundColorVariant() {
      return this.selectColorFor(this.request.statusId);
    },
    foregroundColorVariant() {
      return this.backgroundColorVariant ? "white" : "";
    }
  }
};
